import { render, staticRenderFns } from "./TabeTag.vue?vue&type=template&id=1727c7e2&scoped=true"
import script from "./TabeTag.vue?vue&type=script&lang=js"
export * from "./TabeTag.vue?vue&type=script&lang=js"
import style0 from "./TabeTag.vue?vue&type=style&index=0&id=1727c7e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1727c7e2",
  null
  
)

export default component.exports